// TODO, temporary value, should be changed by data from BE.
export var isBetCheckProject = false;
